export default{
    async updateActiveModalData({commit}, activeModalData){
        commit('updateActiveModalData', activeModalData)
    }
}